export function setQuotations(state, quotations) {
    state.quotations = quotations;
}

export function setFilterDate(state, date) {
    state.params.filter_date = date;
}

export function setFilter(state, filter) {
    state.params.page = 1;
    state.params.filter = filter;
}

export function setPerPage(state, perPage) {
    state.params.page = 1;
    state.params.perPage = perPage;
}

export function setPage(state, page) {
    state.params.page = page;
}

export function setSellers(state, sellers) {
    state.sellers = sellers;
}

export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

export function setSellerIdParams(state, seller_id) {
    state.params.seller_id = seller_id;
}




// WEBPACK FOOTER //
// ./src/modules/quotations/mutations.js